// @flow
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import 'babel-polyfill';

import { PersistGate } from 'redux-persist/es/integration/react';

import store from './store';
import App from './App';
import muiTheme from './theme';
import './index.css';
import persistor from './persistor';
import Loader from './modules/components/Loader';

const onBeforeLift = () => {
  // eslint-disable-next-line no-console
  console.log('redux persistation restoration complete');
};

ReactDOM.render(
  <MuiThemeProvider muiTheme={muiTheme}>
    <Provider store={store}>
      <PersistGate
        loading={<Loader />}
        onBeforeLift={onBeforeLift}
        persistor={persistor}
      >
        <App />
      </PersistGate>
    </Provider>
  </MuiThemeProvider>,
  // $FlowFixMe
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js